import { render, staticRenderFns } from "./CreateBasicSchool.vue?vue&type=template&id=14e46f4a&"
import script from "./CreateBasicSchool.vue?vue&type=script&lang=js&"
export * from "./CreateBasicSchool.vue?vue&type=script&lang=js&"
import style0 from "./CreateBasicSchool.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports